import { schAppraisifyAllowedPropertyTypes } from '@aloft/toolkit-shared';
import { toOpts } from '@aloft/toolkit-sui';

import { PropertyGridSection } from '../../../components/PropertyGrid/columnSections/PropertyGridSection.tsx';
import {
  getAloftAreaJSONPropertyGridField,
  getNumberPropertyGridField,
} from '../../../components/PropertyGrid/fields/utils.tsx';
import { PropertyGridSectionProps } from '../../../components/PropertyGrid/types.ts';

const ONE_TO_SIX = [1, 2, 3, 4, 5, 6];

const prefixedNumbersToOptions = (prefix: string, options: number[]) =>
  options?.map((opt) => ({ label: `${prefix}${opt}`, value: opt }));

export const FeatureGridMainDwellingSection = (props: PropertyGridSectionProps) => (
  <PropertyGridSection
    {...props}
    title="Main Dwelling"
    hasSeparateArvValue
    fields={[
      {
        fieldName: 'editableData.improvements.propertyType',
        label: 'Property Type',
        options: toOpts(schAppraisifyAllowedPropertyTypes.options),
      },
      getNumberPropertyGridField({
        fieldName: 'editableData.improvements.age',
        label: 'Actual Age',
        required: true,
      }),
      getNumberPropertyGridField({
        fieldName: 'editableData.improvements.bedrooms',
        label: 'Bedrooms',
        required: true,
      }),
      getNumberPropertyGridField({
        fieldName: 'editableData.improvements.fullBaths',
        label: 'Baths, Full',
        required: true,
      }),
      getNumberPropertyGridField({
        fieldName: 'editableData.improvements.halfBaths',
        label: 'Baths, Half',
        required: true,
      }),
      getAloftAreaJSONPropertyGridField({
        fieldName: 'editableData.improvements.gla',
        label: 'GLA',
        required: true,
      }),
      getNumberPropertyGridField({
        fieldName: 'editableData.improvements.uadQuality',
        label: 'Quality',
        options: prefixedNumbersToOptions('Q', ONE_TO_SIX),
        autofillSubjectValue: true,
        required: true,
      }),
      getNumberPropertyGridField({
        fieldName: 'editableData.improvements.uadCondition',
        label: 'Condition',
        options: prefixedNumbersToOptions('C', ONE_TO_SIX),
        autofillSubjectValue: true,
        tooltipContent:
          "Major itemized repair costs are handled separately in 'Total Cost to Cure' on the Sales Comparison page, and should not influence this rating.",
        required: true,
      }),
    ]}
  />
);
